import { render, staticRenderFns } from "./aRmsYearSalesColumns.vue?vue&type=template&id=6616991e&scoped=true"
import script from "./aRmsYearSalesColumns.vue?vue&type=script&lang=js"
export * from "./aRmsYearSalesColumns.vue?vue&type=script&lang=js"
import style0 from "./aRmsYearSalesColumns.vue?vue&type=style&index=0&id=6616991e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6616991e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
